import React from 'react'
import { useDispatch } from 'react-redux'
import { ApiWordObject } from '../../lib/interfaces'
import { keepLayer, startLayerTimeout } from './tooltip-functions'
import { setHighlightedWord } from '../../store/tooltip.reducer'
import { useTooltipStore } from '../../hooks/store-hooks'
import { useSetTooltipReference } from './tooltip-reference-context'
import { trackWordTooltipOpen } from 'lib/analytics/events'

type Props = {
   wordObject: ApiWordObject
}

const WordWithTooltip = (props: Props) => {
   const tooltipStore = useTooltipStore()
   const dispatch = useDispatch()
   const setTooltipReference = useSetTooltipReference()
   const thisWord = props.wordObject.word
   // Separable-verb members (ลอง … ดู) share a groupId: hovering one part
   // highlights them all. Only the hovered object itself anchors the tooltip.
   const isHighlighted =
      tooltipStore.highlightedWord === props.wordObject ||
      (props.wordObject.groupId !== undefined &&
         tooltipStore.highlightedWord?.groupId === props.wordObject.groupId)
   const className = isHighlighted ? 't2e_highlight' : ''
   const spaceClass = props.wordObject.hasTrailingSpace ? 'has-space' : ''

   const handleWordMouseover = () => {
      if (!props.wordObject.meanings.length) return
      keepLayer()
      // Deduplicated and capped inside the tracker: hovering along a sentence
      // fires this dozens of times.
      trackWordTooltipOpen(thisWord, props.wordObject.groupId !== undefined)
      dispatch(setHighlightedWord({ highlightedWord: props.wordObject }))
   }

   const handleWordMouseout = () => {
      if (!props.wordObject.meanings.length) return
      startLayerTimeout(() => dispatch(setHighlightedWord({ highlightedWord: undefined })))
   }

   return (
      <span
         ref={props.wordObject === tooltipStore.highlightedWord ? setTooltipReference : undefined}
         className={`t2e thai ${className} ${spaceClass} inline-block`}
         onMouseOver={handleWordMouseover}
         onTouchStart={handleWordMouseover}
         onMouseOut={handleWordMouseout}
      >
         {thisWord}
      </span>
   )
}

export default WordWithTooltip
